var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27 23.1-3.6-3.1v-7.6c0-2.7-.8-4.8-2.4-6.2-1.8-1.6-4.2-1.9-5.4-1.9h-.1c-1.2 0-3.5.2-5.4 1.9-1.6 1.4-2.4 3.5-2.4 6.2v7.6l-3.6 3.1c-.3.3-.4.7-.3 1.1.2.4.5.7.9.7h6.7c.3 2.3 2.1 4.1 4.3 4.1s4-1.8 4.3-4.1h6.1c.4 0 .8-.3.9-.7.4-.3.3-.8 0-1.1zm-11.1 3.9c-1.1 0-2.1-.9-2.3-2.1h4.6c-.2 1.2-1.1 2.1-2.3 2.1zm-8.3-4.1 1.9-1.7c.2-.2.3-.5.3-.8v-8.1c0-2.1.6-3.7 1.7-4.7s2.5-1.3 3.4-1.3h1.3c1 .1 2.4.4 3.4 1.3 1.1 1 1.7 2.6 1.7 4.7v8.1c0 .3.1.6.3.8l1.9 1.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.9ae5f66606cbf5732717cbe9e77bb7d5.svg";
export { ForwardRef as ReactComponent };